import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { RefundHomeServiceOrderMutationVariables } from '@/gql/graphql';
import type { HomeServiceOrderCharge } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderChargeFragment';

export const refundHomeServiceOrder = async (data: RefundHomeServiceOrderMutationVariables['data']) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation RefundHomeServiceOrder($data: HomeServiceOrderRefundInputType!) {
        refundHomeServiceOrder(data: $data) {
          ...HomeServiceOrderChargeFragment
        }
      }
    `),
  });

  return response.data?.refundHomeServiceOrder as HomeServiceOrderCharge;
};
